import classNames from 'classnames'
import { FC, memo } from 'react'

import { useTranslation } from '@crew/modules/i18n'

type Props = {
  className?: string
}

export const CrewAccessDeniedMessage: FC<Props> = memo((props) => {
  const { t } = useTranslation()

  return (
    <div
      className={classNames(
        'flex flex-1 min-h-0 items-center justify-center p-4 text-center',
        props.className
      )}
    >
      <span>{t('message.project.accessDenied')}</span>
    </div>
  )
})
